import React from "react";
import { toastr } from "react-redux-toastr";
import { connect } from "react-redux";
import { FiX } from "react-icons/fi";
import { BiEraser } from "react-icons/bi";
import { RxCopy } from "react-icons/rx";
import moment from "moment";
import {
	FormGroup,
	FormControl,
	FormLabel,
	Nav,
	Tab,
	Modal,
} from "react-bootstrap";
import {
	ContextMenu,
	MenuItem,
	ContextMenuTrigger,
	connectMenu,
} from "react-contextmenu";
import { shiftPatternsService, employeesService, groupsService } from "services";
import { errorFormating } from "utils/utils";
import SubmitButton from "components/SubmitButton";
import { convertFromUTC } from "utils/datetime";
import SwitchCompact from "components/SwitchCompact";
import InlineAlert from "components/InlineAlert";
import FormTextField from "components/FormTextField";
import * as shiftsActions from "actions/shiftsActions";
import * as ubicationsActions from "actions/ubicationsActions";
import { getContrastColor } from "utils/utils";
import Loading from "components/Loading";
import { withTranslation, useTranslation } from "react-i18next";
import ShiftPatternEmployees from "components/ShiftPatterns/ShiftPatternEmployees";
import ShiftPatternShiftTag from "components/ShiftPatterns/ShiftPatternShiftTag";
import ShiftPatternSelector from "components/ShiftPatterns/ShiftPatternSelector";
import CatalogMultiSelect, {
	catalogChip,
} from "components/CatalogMultiSelect/CatalogMultiSelect";
import EmployeeShiftPatternEdit from "components/Employees/EmployeeShiftPatternEditModal";
import EmployeeSelectSearch from "components/EmployeeSelectSearch/EmployeeSelectSearch";
import {
	clickClearsDaySelection,
	cloneDayPattern,
	mapPatternPaste,
	patternTargetIndexes,
	resolvePasteDayIndexes,
	selectDayRange,
	selectionAfterPlainDayClick,
	selectionFromDrag,
	toggleDayIndex,
	toggleRowSelection,
	trimDaySelection,
} from "utils/shiftPatternDaySelection";
import "./ShiftPatternEditModal.scss";

const MENU_ID = "shift_pattern_menu";

const hasDefaultShift = (shift) => Boolean(shift && shift.id != null);

function isEditableKeyboardTarget(target) {
	if (!target || !target.tagName) return false;
	const tag = target.tagName;
	if (tag === "INPUT" || tag === "TEXTAREA" || tag === "SELECT") return true;
	return Boolean(target.isContentEditable);
}

/** Prefijos de id de checkbox distintos a Plan.js (`shift_` / `ubication_`) para evitar colisiones DOM. */
const SP_SHIFT_CHECKBOX_ID_PREFIX = "sp_shift_";
const SP_UBICATION_CHECKBOX_ID_PREFIX = "sp_ubication_";

class ShiftPatternEdit extends React.Component {
	constructor(props) {
		super(props);
		// console.log(props);

		let shift_pattern = {
			name: "",
			items: [],
			length: 7,
			enabled: true,
		};

		const default_shift = this.props.default_shift;

		let isEdit = false;
		let isLoadingDetails = false;

		if (props.shift_pattern) {
			isEdit = true;
			isLoadingDetails = true;
			shift_pattern = { ...props.shift_pattern };
			if (!shift_pattern.items) {
				shift_pattern.items = [];
			}
			shift_pattern.length =
				shift_pattern.length || shift_pattern.items.length || 7;
		}

		// prepare list of options for the lentgh selector
		const length_options = [];
		for (var i = 0; i < 210; i++) {
			length_options.push({
				index: i,
				shift_ubications: [{ shift: default_shift, ubications: [] }],
			});
		}

		this.state = {
			searchShift: "",
			searchUbication: "",
			filterTypeId: "",
			isEdit,
			isLoading: false,
			isLoadingDetails,
			submitted: false,
			errors: {},
			shift_list: props.select_shifts || [],
			ubication_list: props.select_ubications || [],
			shift_pattern,
			length_options,
			employees: [],
			hasGroups: shift_pattern.has_groups || false,
			groupIds:
				shift_pattern.group_ids ||
				(shift_pattern.groups ? shift_pattern.groups.map((g) => g.id) : []),
			groupEmployees: [],
			allGroups: [],
			activePatternTab: "turnos",
			nestedEmployeeModal: null,
			selectedDayIndexes: [],
			selectionAnchor: null,
			copiedDayPattern: [],
		};
	}

	async componentDidMount() {
		this._onWindowMouseUp = () => this.endDayDrag();
		this._onPatternHotkey = (event) => this.handlePatternHotkey(event);
		this._onOutsideDayClick = (event) =>
			this.clearDaySelectionOnOutsideClick(event);
		window.addEventListener("mouseup", this._onWindowMouseUp);
		window.addEventListener("keydown", this._onPatternHotkey);
		// Chrome no dispara click si el mousedown del fondo del modal se cancela.
		window.addEventListener("mousedown", this._onOutsideDayClick, true);
		// carga las listas solo si vienen vacías
		// this.props.getSelectableShifts();
		// this.props.getSelectableUbications();
		// this.props.getShiftTypes();
		// this.props.getDefaultShift();

		const {
			default_shift,
			shift_types,
			select_ubications,
			shifts,
			select_shifts,
			getShiftTypes,
			getDefaultShift,
			getSelectableShifts,
			getSelectableUbications,
		} = this.props;

		this.getAllGroups();

		if (!select_shifts || select_shifts.length === 0) {
			getSelectableShifts();
		}

		if (!select_ubications || select_ubications.length === 0) {
			getSelectableUbications();
		}

		if (!shift_types || shift_types.length === 0) {
			getShiftTypes();
		}

		if (!hasDefaultShift(default_shift)) {
			getDefaultShift();
		}

		if (this.state.isEdit) {
			try {
				const response = await shiftPatternsService.getById(
					this.state.shift_pattern.id
				);
				if (response.ok) {
					this.setState(
						{
							shift_pattern: response,
							hasGroups: response.has_groups || false,
							groupIds: response.groups ? response.groups.map((g) => g.id) : [],
							isLoadingDetails: false,
						},
						() => {
							this.updateItemList();
						}
					);
				} else {
					this.setState({ isLoadingDetails: false });
					toastr.error(
						"Error",
						this.props.t("shiftPatterns.loadError")
					);
				}
			} catch (e) {
				this.setState({ isLoadingDetails: false });
				console.error(e);
			}
		} else {
			if (hasDefaultShift(default_shift)) {
				this.updateItemList();
			}
		}

		await this.getShifts();
	}

	componentWillUnmount() {
		this._unmounted = true;
		clearTimeout(this._outsideClearTimer);
		window.removeEventListener("mouseup", this._onWindowMouseUp);
		window.removeEventListener("keydown", this._onPatternHotkey);
		window.removeEventListener("mousedown", this._onOutsideDayClick, true);
	}

	componentDidUpdate(prevProps) {
		const { default_shift, select_shifts, shifts } = this.props;

		if (
			hasDefaultShift(default_shift) &&
			default_shift.id !== prevProps.default_shift?.id
		) {
			this.syncDefaultShiftIntoPattern(default_shift);
		}

		if (
			this.state.shift_list.length === 0 &&
			((shifts && shifts.length > 0 && shifts !== prevProps.shifts) ||
				(select_shifts &&
					select_shifts.length > 0 &&
					select_shifts !== prevProps.select_shifts))
		) {
			this.setState({
				shift_list:
					shifts && shifts.length > 0 ? shifts : select_shifts || [],
			});
		}
	}

	syncDefaultShiftIntoPattern = (default_shift) => {
		if (!hasDefaultShift(default_shift)) return;

		this.setState(
			(prev) => {
				const length_options = prev.length_options.map((opt) => ({
					...opt,
					shift_ubications: (opt.shift_ubications || []).map((su) =>
						!su.shift ? { ...su, shift: default_shift } : su
					),
				}));

				const items =
					prev.shift_pattern.items.length > 0
						? prev.shift_pattern.items.map((item) => ({
								...item,
								shift_ubications: (item.shift_ubications || []).map(
									(su) =>
										!su.shift
											? {
													shift: default_shift,
													ubications: su.ubications || [],
											  }
											: su
								),
						  }))
						: prev.shift_pattern.items;

				return {
					length_options,
					shift_pattern: {
						...prev.shift_pattern,
						items,
					},
				};
			},
			() => {
				if (!this.state.isEdit && this.state.shift_pattern.items.length === 0) {
					this.updateItemList();
				}
			}
		);
	};

	async getEmployees() {
		const { shift_pattern } = this.state;
		const employeesResponse = await employeesService.getAll({
			history_shift_pattern_id: shift_pattern.id,
			variant: "detailed",
		});
		if (employeesResponse && employeesResponse.data) {
			const employees = await this.resolveEmployeesForCurrentPattern(
				employeesResponse.data
			);
			this.setState({
				employees,
			});
		}
	}

	handlePatternTabSelect = (tabKey) => {
		this.setState({ activePatternTab: tabKey });
		if (
			tabKey === "empleados" &&
			this.state.isEdit &&
			this.state.employees.length === 0
		) {
			this.getEmployees();
		}
	};

	resolveShiftPatternAssignmentList = (res) => {
		if (!res || res.ok === false) return null;
		if (Array.isArray(res)) return res;
		if (Array.isArray(res.data)) return res.data;
		return [];
	};

	getMostRecentAssignmentForPattern = (patterns, shiftPatternId) =>
		patterns
			.filter(
				(pattern) =>
					pattern.shift_pattern &&
					Number(pattern.shift_pattern.id) === Number(shiftPatternId)
			)
			.sort(
				(a, b) =>
					moment(b.start_day).valueOf() - moment(a.start_day).valueOf()
			)[0] || null;

	resolveEmployeesForCurrentPattern = async (employees) => {
		const shiftPatternId = this.state.shift_pattern.id;

		return Promise.all(
			employees.map(async (employee) => {
				const currentAssignment = employee.employee_with_shift_pattern;
				const currentPatternId = currentAssignment && currentAssignment.shift_pattern
					? currentAssignment.shift_pattern.id
					: null;

				if (Number(currentPatternId) === Number(shiftPatternId)) {
					return employee;
				}

				const response = await employeesService.getShiftPatterns(employee.id);
				const patterns = this.resolveShiftPatternAssignmentList(response);
				if (patterns === null) return employee;

				const assignment = this.getMostRecentAssignmentForPattern(
					patterns,
					shiftPatternId
				);

				return assignment
					? { ...employee, employee_with_shift_pattern: assignment }
					: employee;
			})
		);
	};

	closeNestedEmployeeModal = () => {
		this.setState({ nestedEmployeeModal: null });
	};

	findAssignmentForCurrentPattern = async (employeeId) => {
		const { shift_pattern } = this.state;
		if (!shift_pattern.id) return null;
		try {
			const res = await employeesService.getShiftPatterns(employeeId);
			const patterns = this.resolveShiftPatternAssignmentList(res);
			if (patterns === null) {
				toastr.error(
					this.props.t("common.error"),
					this.props.t("shiftPatterns.loadAssignmentsError")
				);
				return null;
			}
			return this.getMostRecentAssignmentForPattern(patterns, shift_pattern.id);
		} catch (e) {
			console.error(e);
			toastr.error(
				this.props.t("common.error"),
				this.props.t("shiftPatterns.loadAssignmentsError")
			);
			return null;
		}
	};

	openNestedEditAssignment = async (employee) => {
		const esp = await this.findAssignmentForCurrentPattern(employee.id);
		if (!esp) {
			toastr.error(
				this.props.t("common.error"),
				this.props.t("shiftPatterns.assignmentNotFoundForEmployee")
			);
			return;
		}
		this.setState({
			nestedEmployeeModal: {
				type: "edit",
				employee: {
					id: employee.id,
					name: employee.name,
					surname: employee.surname,
				},
				employee_shift_pattern: esp,
			},
		});
	};

	ensureShiftPatternPersisted = async () => {
		const { shift_pattern } = this.state;
		if (shift_pattern && shift_pattern.id) return shift_pattern.id;

		this.setState({ isLoading: true });
		const payload = this.prepareShiftPatternSubmit();
		const response = await shiftPatternsService.add(payload);

		if (!response.ok) {
			this.setState({
				isLoading: false,
				submitted: true,
				errors: errorFormating(response),
			});
			return null;
		}

		const persistedShiftPattern = { ...payload, ...response };
		this.setState({
			isLoading: false,
			isEdit: true,
			errors: {},
			shift_pattern: persistedShiftPattern,
		});
		this.props.getShiftPatterns();
		toastr.success(this.props.t("common.success"), this.props.t("shiftPatterns.savedOk"));
		return persistedShiftPattern.id;
	};

	openNestedAddPickEmployee = async () => {
		const shiftPatternId = await this.ensureShiftPatternPersisted();
		if (!shiftPatternId) {
			toastr.warning("", this.props.t("shiftPatterns.checkRequired"));
			return;
		}
		this.setState({
			nestedEmployeeModal: { type: "pick", selectedId: null, selectedEmployee: null },
		});
	};

	handlePickEmployeeContinue = () => {
		const m = this.state.nestedEmployeeModal;
		if (!m || m.type !== "pick" || !m.selectedId) {
			toastr.warning("", this.props.t("shiftPatterns.selectEmployee"));
			return;
		}
		this.setState({
			nestedEmployeeModal: {
				type: "assign",
				employee: m.selectedEmployee || { id: m.selectedId },
			},
		});
	};

	openNestedDeleteAssignment = async (employee) => {
		const esp = await this.findAssignmentForCurrentPattern(employee.id);
		if (!esp) {
			toastr.error(this.props.t("common.error"), this.props.t("shiftPatterns.assignmentNotFound"));
			return;
		}
		this.setState({
			nestedEmployeeModal: {
				type: "delete",
				employee,
				assignmentId: esp.id,
				isSubmitting: false,
			},
		});
	};

	openNestedCloneAssignment = (employee) => {
		this.setState({
			nestedEmployeeModal: {
				type: "clone",
				sourceEmployee: employee,
				selectedIds: [],
				isSubmitting: false,
			},
		});
	};

	handleCloneAssignmentConfirm = async () => {
		const { nestedEmployeeModal, shift_pattern } = this.state;
		if (!nestedEmployeeModal || nestedEmployeeModal.type !== "clone") return;
		const selectedIds = Array.isArray(nestedEmployeeModal.selectedIds)
			? nestedEmployeeModal.selectedIds.map((id) => Number(id)).filter(Boolean)
			: [];
		if (selectedIds.length === 0) {
			toastr.warning("", this.props.t("shiftPatterns.selectAtLeastOneTarget"));
			return;
		}
		const sourceId = Number(nestedEmployeeModal.sourceEmployee.id);
		if (selectedIds.includes(sourceId)) {
			toastr.warning("", this.props.t("shiftPatterns.cannotCloneSameEmployee"));
			return;
		}

		this.setState((prev) => ({
			nestedEmployeeModal:
				prev.nestedEmployeeModal && prev.nestedEmployeeModal.type === "clone"
					? { ...prev.nestedEmployeeModal, isSubmitting: true }
					: prev.nestedEmployeeModal,
		}));

		try {
			let sourceAssignment =
				nestedEmployeeModal.sourceEmployee.employee_with_shift_pattern || null;
			if (!sourceAssignment) {
				sourceAssignment = await this.findAssignmentForCurrentPattern(
					nestedEmployeeModal.sourceEmployee.id
				);
			}
			if (!sourceAssignment) {
				toastr.error(this.props.t("common.error"), this.props.t("shiftPatterns.cloneSourceError"));
				this.setState((prev) => ({
					nestedEmployeeModal:
						prev.nestedEmployeeModal && prev.nestedEmployeeModal.type === "clone"
							? { ...prev.nestedEmployeeModal, isSubmitting: false }
							: prev.nestedEmployeeModal,
				}));
				return;
			}

			const payload = {
				shift_pattern_id:
					sourceAssignment.shift_pattern_id ||
					(sourceAssignment.shift_pattern && sourceAssignment.shift_pattern.id) ||
					shift_pattern.id,
				start_day: sourceAssignment.start_day,
				end_day:
					sourceAssignment.end_day === undefined
						? null
						: sourceAssignment.end_day,
				start_index:
					sourceAssignment.start_index === undefined
						? 0
						: sourceAssignment.start_index,
				ubication_id: sourceAssignment.ubication
					? sourceAssignment.ubication.id
					: sourceAssignment.ubication_id || null,
			};

			const results = await Promise.all(
				selectedIds.map(async (employeeId) => {
					const res = await employeesService.addShiftPattern(employeeId, payload);
					return { employeeId, res };
				})
			);
			const failed = results.filter(({ res }) => !res || !res.ok);
			const successCount = results.length - failed.length;
			const t = this.props.t;
			const successLabel = t("shiftPatterns.list.employeeCount", { count: successCount });
			const failedLabel = t("shiftPatterns.list.employeeCount", { count: failed.length });
			const failedVerb = t("shiftPatterns.failedVerb", { count: failed.length });

			if (failed.length > 0) {
				const firstError = errorFormating(failed[0].res || {});
				const baseMessage =
					successCount === 0
						? t("shiftPatterns.allFailed", { failedLabel, failedVerb })
						: t("shiftPatterns.clonedInPartial", { successLabel, failedLabel, failedVerb });
				toastr.warning(
					"",
					`${baseMessage} ${firstError.general || ""}`.trim()
				);
			} else {
				toastr.success(
					t("common.success"),
					t("shiftPatterns.clonedIn", { label: successLabel })
				);
			}
			this.closeNestedEmployeeModal();
			this.getEmployees();
		} catch (e) {
			console.error(e);
			toastr.error(this.props.t("common.error"), this.props.t("shiftPatterns.cloneAssignmentError"));
			this.setState((prev) => ({
				nestedEmployeeModal:
					prev.nestedEmployeeModal && prev.nestedEmployeeModal.type === "clone"
						? { ...prev.nestedEmployeeModal, isSubmitting: false }
						: prev.nestedEmployeeModal,
			}));
		}
	};

	confirmNestedDelete = async () => {
		const { nestedEmployeeModal } = this.state;
		if (!nestedEmployeeModal || nestedEmployeeModal.type !== "delete" || nestedEmployeeModal.isSubmitting) return;
		const { employee, assignmentId } = nestedEmployeeModal;

		this.setState((prev) => ({
			nestedEmployeeModal: prev.nestedEmployeeModal
				? { ...prev.nestedEmployeeModal, isSubmitting: true }
				: prev.nestedEmployeeModal,
		}));

		try {
			const res = await employeesService.removeShiftPattern(
				employee.id,
				assignmentId
			);
			if (!res.ok) {
				const err = errorFormating(res);
				toastr.error(
					this.props.t("common.error"),
					err.general || err.id || this.props.t("shiftPatterns.deleteAssignmentError")
				);
				this.setState((prev) => ({
					nestedEmployeeModal: prev.nestedEmployeeModal
						? { ...prev.nestedEmployeeModal, isSubmitting: false }
						: prev.nestedEmployeeModal,
				}));
				return;
			}
			toastr.success(this.props.t("common.success"), this.props.t("shiftPatterns.assignmentDeleted"));
			this.closeNestedEmployeeModal();
			this.getEmployees();
		} catch (e) {
			console.error(e);
			toastr.error(this.props.t("common.error"), this.props.t("shiftPatterns.deleteAssignmentError"));
			this.setState((prev) => ({
				nestedEmployeeModal: prev.nestedEmployeeModal
					? { ...prev.nestedEmployeeModal, isSubmitting: false }
					: prev.nestedEmployeeModal,
			}));
		}
	};

	onEmployeeAssignmentSaved = () => {
		this.getEmployees();
		this.closeNestedEmployeeModal();
		if (typeof this.props.onAssignmentSaved === "function") {
			this.props.onAssignmentSaved();
		}
	};

	/** Evita que el modal de rueda (react-modal) reciba foco/ESC y se cierre al abrir modales Bootstrap hijos. */
	getNestedEmployeeBsModalProps = (opts = {}) => ({
		enforceFocus: false,
		restoreFocus: false,
		onEscapeKeyDown: (e) => e.stopPropagation(),
		className: "sp-nested-on-shift-pattern",
		backdropClassName: "sp-nested-on-shift-pattern-backdrop",
		...opts,
	});

	renderNestedEmployeeModals = () => {
		const { nestedEmployeeModal, shift_pattern } = this.state;
		if (!nestedEmployeeModal) return null;

		if (nestedEmployeeModal.type === "pick") {
			return (
				<Modal
					{...this.getNestedEmployeeBsModalProps()}
					show
					onHide={this.closeNestedEmployeeModal}
					centered
					dialogClassName="sp-nested-assign-modal"
				>
					<Modal.Header closeButton>
						<Modal.Title>{this.props.t("shiftPatterns.nestedModal.assignEmployeeTitle")}</Modal.Title>
					</Modal.Header>
					<Modal.Body>
						<FormGroup controlId="pick-employee-shift-pattern">
							<FormLabel>
								{this.props.t("common.employee")} <span className="label-required">*</span>
							</FormLabel>
							<EmployeeSelectSearch
								className="employee-select-search--fullwidth"
								controlId="pick-employee-shift-pattern"
								multiple={false}
								value={
									nestedEmployeeModal.selectedId
										? String(nestedEmployeeModal.selectedId)
										: null
								}
								onChange={(id, emp) =>
									this.setState((prev) => ({
										nestedEmployeeModal:
											prev.nestedEmployeeModal &&
											prev.nestedEmployeeModal.type === "pick"
												? {
														...prev.nestedEmployeeModal,
														selectedId: id ? Number(id) : null,
														selectedEmployee: emp || null,
												  }
												: prev.nestedEmployeeModal,
									}))
								}
								placeholder={this.props.t("shiftPatterns.nestedModal.searchEmployeePlaceholder")}
								allLabel={this.props.t("shiftPatterns.nestedModal.searchEmployeePlaceholder")}
								allowClear={false}
							/>
						</FormGroup>
					</Modal.Body>
					<Modal.Footer>
						<button
							type="button"
							className="btn btn-outline-primary"
							onClick={this.closeNestedEmployeeModal}
						>
							{this.props.t("common.cancel")}
						</button>
						<button
							type="button"
							className="btn btn-primary"
							onClick={this.handlePickEmployeeContinue}
						>
							{this.props.t("common.continue")}
						</button>
					</Modal.Footer>
				</Modal>
			);
		}

		if (nestedEmployeeModal.type === "assign") {
			return (
				<Modal
					{...this.getNestedEmployeeBsModalProps()}
					show
					onHide={this.closeNestedEmployeeModal}
					centered
					dialogClassName="sp-nested-assign-modal"
				>
					<Modal.Header closeButton>
						<Modal.Title>{this.props.t("shiftPatterns.assignment.assign")}</Modal.Title>
					</Modal.Header>
					<EmployeeShiftPatternEdit
						handleClose={this.closeNestedEmployeeModal}
						employee={nestedEmployeeModal.employee}
						lockedShiftPatternId={shift_pattern.id}
						lockedShiftPatternName={shift_pattern.name}
						onAssignmentSaved={this.onEmployeeAssignmentSaved}
					/>
				</Modal>
			);
		}

		if (nestedEmployeeModal.type === "edit") {
			return (
				<Modal
					{...this.getNestedEmployeeBsModalProps()}
					show
					onHide={this.closeNestedEmployeeModal}
					centered
					dialogClassName="sp-nested-assign-modal"
				>
					<Modal.Header closeButton>
						<Modal.Title>{this.props.t("shiftPatterns.assignment.editAssignment")}</Modal.Title>
					</Modal.Header>
					<EmployeeShiftPatternEdit
						handleClose={this.closeNestedEmployeeModal}
						employee={nestedEmployeeModal.employee}
						employee_shift_pattern={nestedEmployeeModal.employee_shift_pattern}
						onAssignmentSaved={this.onEmployeeAssignmentSaved}
					/>
				</Modal>
			);
		}

		if (nestedEmployeeModal.type === "delete") {
			const emp = nestedEmployeeModal.employee;
			return (
				<Modal
					{...this.getNestedEmployeeBsModalProps({ backdrop: "static" })}
					show
					onHide={this.closeNestedEmployeeModal}
					centered
					dialogClassName="sp-nested-assign-modal"
				>
					<Modal.Header closeButton>
						<Modal.Title>{this.props.t("shiftPatterns.assignment.deleteAssignment")}</Modal.Title>
					</Modal.Header>
					<Modal.Body>
						{this.props.t("shiftPatterns.nestedModal.deleteConfirmMsg", { name: emp.name, surname: emp.surname })}
					</Modal.Body>
					<Modal.Footer>
						<button
							type="button"
							className="btn btn-outline-primary"
							onClick={this.closeNestedEmployeeModal}
							disabled={nestedEmployeeModal.isSubmitting}
						>
							{this.props.t("common.cancel")}
						</button>
						<SubmitButton
							type="button"
							variant="danger"
							onClick={this.confirmNestedDelete}
							isLoading={nestedEmployeeModal.isSubmitting}
							text={this.props.t("common.delete")}
							loadingText={this.props.t("common.deleting")}
						/>
					</Modal.Footer>
				</Modal>
			);
		}

		if (nestedEmployeeModal.type === "clone") {
			const source = nestedEmployeeModal.sourceEmployee;
			return (
				<Modal
					{...this.getNestedEmployeeBsModalProps()}
					show
					onHide={this.closeNestedEmployeeModal}
					centered
					dialogClassName="sp-nested-assign-modal"
				>
					<Modal.Header closeButton>
						<Modal.Title>{this.props.t("shiftPatterns.employees.cloneAssignment")}</Modal.Title>
					</Modal.Header>
					<Modal.Body>
						<p className="mb-3">
							{this.props.t("shiftPatterns.nestedModal.cloneAssignmentFrom", { name: source.name, surname: source.surname })}
						</p>
						<FormGroup controlId="clone-employee-shift-pattern">
							<FormLabel>
								{this.props.t("shiftPatterns.nestedModal.targetEmployeeLabel")} <span className="label-required">*</span>
							</FormLabel>
							<EmployeeSelectSearch
								className="employee-select-search--fullwidth"
								controlId="clone-employee-shift-pattern"
								multiple
								value={nestedEmployeeModal.selectedIds || []}
								onChange={(ids) =>
									this.setState((prev) => ({
										nestedEmployeeModal:
											prev.nestedEmployeeModal &&
											prev.nestedEmployeeModal.type === "clone"
												? {
														...prev.nestedEmployeeModal,
														selectedIds: Array.isArray(ids) ? ids : [],
												  }
												: prev.nestedEmployeeModal,
									}))
								}
								placeholder={this.props.t("shiftPatterns.nestedModal.searchEmployeesPlaceholder")}
								allLabel={this.props.t("shiftPatterns.nestedModal.selectEmployeesAllLabel")}
								allowClear
							/>
						</FormGroup>
					</Modal.Body>
					<Modal.Footer>
						<button
							type="button"
							className="btn btn-outline-primary"
							onClick={this.closeNestedEmployeeModal}
							disabled={nestedEmployeeModal.isSubmitting}
						>
							{this.props.t("common.cancel")}
						</button>
						<SubmitButton
							type="button"
							isLoading={nestedEmployeeModal.isSubmitting}
							text={this.props.t("shiftPatterns.clone")}
							loadingText={this.props.t("shiftPatterns.nestedModal.clonandoBtn")}
							onClick={this.handleCloneAssignmentConfirm}
						/>
					</Modal.Footer>
				</Modal>
			);
		}

		return null;
	};

	async getAllGroups() {
		try {
			// variant: "detailed" is used in Groups page and works.
			const groups = await groupsService.getAll({ variant: "detailed" });
			if (groups) {
				if (Array.isArray(groups)) {
					this.setState({ allGroups: groups });
				} else if (groups.data) {
					this.setState({ allGroups: groups.data });
				}
			}
		} catch (e) {
			console.error(e);
		}
	}

	getGroupEmployees() {
		// No longer needed as we display the list of groups directly.
		// Kept empty or remove if preferred.
	}

	getPatternGroups = () => {
		const { allGroups, shift_pattern } = this.state;
		const catalog = allGroups || [];
		const extras = (shift_pattern.groups || []).filter(
			(group) => !catalog.some((item) => Number(item.id) === Number(group.id))
		);
		return [...catalog, ...extras];
	};

	getSelectedPatternGroups = (groups) => {
		const byId = new Map((groups || []).map((group) => [Number(group.id), group]));
		return (this.state.groupIds || []).map((id) => {
			const numericId = Number(id);
			return (
				byId.get(numericId) || {
					id: numericId,
					name: `${this.props.t("shiftPatterns.form.groupId")} ${numericId}`,
				}
			);
		});
	};

	togglePatternGroup = (group) => {
		const id = Number(group.id);
		this.setState((prev) => {
			const ids = (prev.groupIds || []).map((value) => Number(value));
			const exists = ids.includes(id);
			return {
				groupIds: exists ? ids.filter((value) => value !== id) : [...ids, id],
			};
		});
	};

	clearPatternGroups = () => {
		this.setState({ groupIds: [] });
	};

	async getShifts() {
		const shift_list = await this.props.getAllShifts({
			q: this.state.searchShift,
			shift_type: this.state.filterTypeId,
		});

		this.setState({
			shift_list: shift_list || [],
		});
	}

	async getUbications() {
		const ubication_list = await this.props.getSelectableUbications({
			q: this.state.searchUbication,
		});

		this.setState({
			ubication_list: ubication_list || [],
		});
	}

	updateItemList = () => {
		const { shift_pattern, length_options } = this.state;
		var items = [];

		// console.log(length_options);
		// console.log(shift_pattern.items.length);
		// console.log(shift_pattern.length);

		// si no había una lista de items previa, se usa la lista vacía
		if (shift_pattern.items.length === 0)
			items = length_options.slice(0, shift_pattern.length);
		// si la lista previa era más larga que la nueva longitud, acortamos
		else if (shift_pattern.items.length >= shift_pattern.length * 1) {
			items = shift_pattern.items.slice(0, shift_pattern.length);
		}
		// si la lista previa era más corta sumamos los elementos restantes de la lista vacía
		else {
			const temp_items_1 = length_options.slice(
				shift_pattern.items.length,
				shift_pattern.length
			);
			const temp_items_2 = shift_pattern.items.slice(0, shift_pattern.length);

			items = temp_items_2.concat(temp_items_1);
		}

		const length = items.length;
		const selectionAnchor = this.state.selectionAnchor;

		this.setState({
			shift_pattern: {
				...shift_pattern,
				items: items,
			},
			selectedDayIndexes: trimDaySelection(
				this.state.selectedDayIndexes,
				length
			),
			selectionAnchor:
				Number.isInteger(selectionAnchor) && selectionAnchor < length
					? selectionAnchor
					: null,
		});
	};

	handleChange = (event) => {
		const { shift_pattern } = this.state;
		const key = event.target.id;

		this.setState(
			{
				shift_pattern: {
					...shift_pattern,
					[event.target.id]: event.target.value,
				},
			},
			() => {
				// when the updated field is length, update the whole grid
				if (key === "length") {
					this.updateItemList();
				}
			}
		);
	};

	handlePatternLengthChange = (event) => {
		const value = event.target.value;
		const { shift_pattern } = this.state;
		this.setState(
			{
				shift_pattern: {
					...shift_pattern,
					length: value,
				},
			},
			() => this.updateItemList()
		);
	};

	handleSwitch = (event) => {
		const key = event.target.id;
		const checked = event.target.checked;

		this.setState((prev) => {
			const shift_pattern = {
				...prev.shift_pattern,
				[key]: checked,
			};
			let { activePatternTab } = prev;
			if (
				key === "has_ubications" &&
				!checked &&
				activePatternTab === "ubicaciones"
			) {
				activePatternTab = "turnos";
			}
			return { shift_pattern, activePatternTab };
		});
	};

	handleShiftSelection = (event) => {
		event.stopPropagation();
		const { shift_list } = this.state;
		const countSelected = shift_list.filter((o) => o.checked === true).length;
		const id = String(event.target.id).replace(SP_SHIFT_CHECKBOX_ID_PREFIX, "");
		const value = event.target.checked;

		if (countSelected >= 3 && value) {
			toastr.error("", this.props.t("shiftPatterns.form.maxShifts"));
		} else {
			this.setState({
				shift_list: this.state.shift_list.map((o) =>
					o.id === parseInt(id) ? { ...o, checked: value } : o
				),
			});
		}
	};

	handleUbicationSelection = (event) => {
		event.stopPropagation();
		const { ubication_list } = this.state;
		const countSelected = ubication_list.filter(
			(o) => o.checked === true
		).length;
		const id = String(event.target.id).replace(
			SP_UBICATION_CHECKBOX_ID_PREFIX,
			""
		);
		const value = event.target.checked;

		if (countSelected >= 2 && value) {
			toastr.error("", this.props.t("shiftPatterns.form.maxUbications"));
		} else {
			this.setState({
				ubication_list: this.state.ubication_list.map((o) =>
					o.id === parseInt(id) ? { ...o, checked: value } : o
				),
			});
		}
	};

	handleShiftSearchChange = (event) => {
		this.setState({ searchShift: event.target.value }, () => this.getShifts());
	};

	handleUbicationSearchChange = (event) => {
		this.setState({ searchUbication: event.target.value }, () =>
			this.getUbications()
		);
	};

	handleFilterTypeChange = (event) => {
		this.setState({ filterTypeId: event.target.value }, () => this.getShifts());
	};

	handlePaletteBorrar = () => {
		this.setState({
			shift_list: this.state.shift_list.map((o) => ({ ...o, checked: false })),
		});
	};

	handleUbicationPaletteBorrar = () => {
		this.setState({
			ubication_list: this.state.ubication_list.map((o) => ({
				...o,
				checked: false,
			})),
		});
	};

	handleClearAllPattern = () => {
		const { shift_pattern } = this.state;
		const default_shift = this.props.default_shift;
		const items = shift_pattern.items.map((item) => ({
			...item,
			checked: false,
			shift_ubications: [{ shift: default_shift, ubications: [] }],
		}));
		this.setState({
			shift_pattern: { ...shift_pattern, items },
			errors: {},
			selectedDayIndexes: [],
		});
	};

	/** Añade turnos de `filteredShifts` al día, sin duplicar IDs, máx. 3 turnos por día. */
	mergeShiftsIntoDayItem = (item, filteredShifts, { notify = true } = {}) => {
		const default_shift = this.props.default_shift;
		let working = (item.shift_ubications || []).filter(
			(su) =>
				su.shift && (!default_shift || su.shift.id !== default_shift.id)
		);
		const ids = new Set(working.map((su) => su.shift.id));
		const toAdd = filteredShifts.filter((s) => !ids.has(s.id));
		if (toAdd.length === 0) {
			return item;
		}
		if (working.length + toAdd.length > 3) {
			if (notify) {
				toastr.error("", this.props.t("shiftPatterns.form.maxShifts"));
			}
			return null;
		}
		const shift_ubications = [
			...working,
			...toAdd.map((shift) => ({ shift, ubications: [] })),
		];
		return { ...item, shift_ubications, checked: false };
	};

	applySelectedShiftsToDays = (indexes, options = {}) => {
		const {
			clearSelection = "ifChanged",
			selectionAnchor,
			nextSelection,
		} = options;
		const targets = [
			...new Set((indexes || []).filter((index) => Number.isInteger(index))),
		];
		if (targets.length === 0) return;

		const anchorPatch = Number.isInteger(selectionAnchor)
			? { selectionAnchor }
			: {};
		const keptSelection = Array.isArray(nextSelection)
			? nextSelection
			: this.state.selectedDayIndexes;
		const { shift_pattern } = this.state;
		const filteredShifts = this._filterSelected(this.state.shift_list);
		if (filteredShifts.length === 0) {
			if (clearSelection === "always") {
				this.setState({ selectedDayIndexes: [], ...anchorPatch });
			} else if (Array.isArray(nextSelection)) {
				this.setState({ selectedDayIndexes: nextSelection, ...anchorPatch });
			}
			return;
		}

		const targetSet = new Set(targets);
		let blocked = false;
		let changed = false;
		const items = shift_pattern.items.map((item) => {
			if (!targetSet.has(item.index)) return item;
			const next = this.mergeShiftsIntoDayItem(item, filteredShifts, {
				notify: false,
			});
			if (next === null) {
				blocked = true;
				return item;
			}
			if (next !== item) changed = true;
			return next;
		});

		if (blocked) {
			toastr.error("", this.props.t("shiftPatterns.form.maxShifts"));
		}

		const dropSelection =
			clearSelection === "always" ||
			(clearSelection === "ifChanged" && changed);

		this.setState({
			shift_pattern: { ...shift_pattern, items },
			errors: {},
			selectedDayIndexes: dropSelection ? [] : keptSelection,
			...anchorPatch,
		});
	};

	applySelectedShiftsToDay = (index) => {
		this.applySelectedShiftsToDays([index]);
	};

	handlePasteSelectedDays = (event) => {
		event.preventDefault();
		this.applySelectedShiftsToDays(this.state.selectedDayIndexes);
	};

	beginDayDrag = (event, index) => {
		if (event.button !== 0) return;
		if (event.target.closest && event.target.closest(".sp-grid-shift-remove")) {
			return;
		}

		const additive = event.ctrlKey || event.metaKey;
		this._dayDrag = {
			startIndex: index,
			moved: false,
			additive,
			base: additive ? [...(this.state.selectedDayIndexes || [])] : [],
		};
	};

	handleDayMouseEnter = (event, index) => {
		const drag = this._dayDrag;
		if (!drag || this._unmounted) return;
		if (event.buttons !== 1) {
			this.endDayDrag();
			return;
		}
		if (index === drag.startIndex && !drag.moved) return;

		drag.moved = true;
		this.setState({
			selectedDayIndexes: selectionFromDrag({
				startIndex: drag.startIndex,
				endIndex: index,
				base: drag.base,
				additive: drag.additive,
			}),
			selectionAnchor: drag.startIndex,
		});
	};

	endDayDrag = () => {
		if (!this._dayDrag) return;
		const moved = this._dayDrag.moved;
		this._dayDrag = null;
		if (!moved) return;

		this._suppressDayClick = true;
		setTimeout(() => {
			this._suppressDayClick = false;
		}, 0);
	};

	handleDayContextMenu = (index) => {
		// En macOS Ctrl+clic abre el menú contextual y también dispara click.
		this._ignoreNextDayClick = true;
		setTimeout(() => {
			this._ignoreNextDayClick = false;
		}, 0);

		this.setState((prev) => {
			const selected = prev.selectedDayIndexes || [];
			if (selected.includes(index)) {
				return null;
			}
			return {
				selectedDayIndexes: [...selected, index],
				selectionAnchor: index,
			};
		});
	};

	clearDaySelectionOnOutsideClick = (event) => {
		if (this._unmounted || (event.button != null && event.button !== 0)) return;

		const shouldClear = clickClearsDaySelection(event.target, {
			hasSelection: (this.state.selectedDayIndexes || []).length > 0,
			suppressClick: this._suppressDayClick,
		});
		clearTimeout(this._outsideClearTimer);
		if (!shouldClear) return;

		// Después del mousedown, para no robar el foco ni el clic del control pulsado.
		this._outsideClearTimer = setTimeout(() => {
			if (this._unmounted) return;
			if ((this.state.selectedDayIndexes || []).length === 0) return;
			this.setState({ selectedDayIndexes: [] });
		}, 0);
	};

	handleDayAssignClick = (event, index) => {
		event.preventDefault();
		event.stopPropagation();

		if (this._suppressDayClick || this._ignoreNextDayClick) {
			this._suppressDayClick = false;
			this._ignoreNextDayClick = false;
			return;
		}

		if (event.ctrlKey || event.metaKey) {
			this.setState((prev) => ({
				selectedDayIndexes: toggleDayIndex(prev.selectedDayIndexes, index),
				selectionAnchor: index,
			}));
			return;
		}

		if (event.shiftKey) {
			this.setState((prev) => ({
				selectedDayIndexes: selectDayRange(prev.selectionAnchor, index),
				selectionAnchor: Number.isInteger(prev.selectionAnchor)
					? prev.selectionAnchor
					: index,
			}));
			return;
		}

		const selected = this.state.selectedDayIndexes || [];
		const nextSelection = selectionAfterPlainDayClick(selected, index);
		if (selected.length > 0) {
			this.setState({
				selectedDayIndexes: nextSelection,
				selectionAnchor: index,
			});
			return;
		}

		this.applySelectedShiftsToDays([index], {
			clearSelection: "never",
			selectionAnchor: index,
			nextSelection,
		});
	};

	handleWeekRowSelection = (rowIndexes) => {
		this.setState((prev) => ({
			selectedDayIndexes: toggleRowSelection(
				prev.selectedDayIndexes,
				rowIndexes
			),
			selectionAnchor: rowIndexes[0] ?? prev.selectionAnchor,
		}));
	};

	clearShiftsOnSelectedDays = () => {
		const selected = new Set(this.state.selectedDayIndexes || []);
		if (selected.size === 0) return;

		const default_shift = this.props.default_shift;
		const { shift_pattern } = this.state;
		const items = shift_pattern.items.map((item) => {
			if (!selected.has(item.index)) return item;
			return {
				...item,
				checked: false,
				shift_ubications: [{ shift: default_shift, ubications: [] }],
			};
		});

		this.setState({
			shift_pattern: { ...shift_pattern, items },
			errors: {},
		});
	};

	copySelectedDayPattern = () => {
		const selected = [...(this.state.selectedDayIndexes || [])].sort(
			(a, b) => a - b
		);
		if (selected.length === 0) return;

		const byIndex = new Map(
			this.state.shift_pattern.items.map((item) => [item.index, item])
		);
		const copiedDayPattern = selected.map((index) =>
			cloneDayPattern(byIndex.get(index))
		);

		this.setState({
			copiedDayPattern,
			shift_list: this.state.shift_list.map((shift) => ({
				...shift,
				checked: false,
			})),
		});
		toastr.success(
			this.props.t("common.success"),
			this.props.t("shiftPatterns.form.patternCopied", {
				count: selected.length,
			})
		);
	};

	pasteCopiedDayPattern = () => {
		const pattern = this.state.copiedDayPattern || [];
		if (pattern.length === 0) return;

		const { shift_pattern } = this.state;
		const targets = patternTargetIndexes(
			this.state.selectedDayIndexes,
			this.state.selectionAnchor,
			pattern.length,
			shift_pattern.items.length
		);
		if (targets.length === 0) return;

		const pasted = new Map(
			mapPatternPaste(pattern, targets).map((slot) => [
				slot.index,
				slot.shiftUbications,
			])
		);
		const items = shift_pattern.items.map((item) => {
			if (!pasted.has(item.index)) return item;
			return {
				...item,
				checked: false,
				shift_ubications: pasted.get(item.index),
			};
		});

		this.setState({
			shift_pattern: { ...shift_pattern, items },
			errors: {},
			selectedDayIndexes: targets,
			selectionAnchor: targets[0],
		});
		toastr.success(
			this.props.t("common.success"),
			this.props.t("shiftPatterns.form.patternPasted", {
				count: targets.length,
			})
		);
	};

	handlePatternHotkey = (event) => {
		if (this._unmounted || this.state.activePatternTab !== "turnos") return;
		if (isEditableKeyboardTarget(event.target)) return;

		const key = String(event.key || "").toLowerCase();
		const withModifier = (event.ctrlKey || event.metaKey) && !event.altKey;
		const hasDaySelection = (this.state.selectedDayIndexes || []).length > 0;

		if (withModifier && key === "c") {
			if (!hasDaySelection) return;
			event.preventDefault();
			this.copySelectedDayPattern();
			return;
		}

		if (withModifier && key === "v") {
			if ((this.state.copiedDayPattern || []).length === 0) return;
			event.preventDefault();
			this.pasteCopiedDayPattern();
			return;
		}

		if ((event.key === "Delete" || event.key === "Backspace") && hasDaySelection) {
			event.preventDefault();
			this.clearShiftsOnSelectedDays();
		}
	};

	/**
	 * Añade ubicaciones seleccionadas a un único turno del día (máx. 2 en ese turno).
	 */
	mergeUbicationsIntoOneShift = (item, shiftId, filteredUbications) => {
		const default_shift = this.props.default_shift;
		const targetId = Number(shiftId);
		if (
			!shiftId ||
			!Number.isFinite(targetId) ||
			(default_shift && targetId === Number(default_shift.id))
		) {
			return null;
		}

		let blocked = false;
		let anyChange = false;
		const nextShiftUbications = (item.shift_ubications || []).map((su) => {
			if (!su.shift || Number(su.shift.id) !== targetId) return su;
			const existing = su.ubications || [];
			const ids = new Set(existing.map((u) => u.id));
			const toAdd = filteredUbications.filter((u) => !ids.has(u.id));
			if (toAdd.length === 0) return su;
			if (existing.length + toAdd.length > 2) {
				blocked = true;
				return su;
			}
			anyChange = true;
			return { ...su, ubications: [...existing, ...toAdd] };
		});

		if (blocked) {
			toastr.error("", this.props.t("shiftPatterns.form.maxUbications"));
			return null;
		}
		if (!anyChange) {
			return { ...item, checked: false };
		}
		return { ...item, shift_ubications: nextShiftUbications, checked: false };
	};

	itemHasAssignableShifts = (sp_item) => {
		const default_shift = this.props.default_shift;
		return (sp_item.shift_ubications || []).some(
			(su) =>
				su.shift && (!default_shift || su.shift.id !== default_shift.id)
		);
	};

	getUbicationShiftBlocks = (item) => {
		const default_shift = this.props.default_shift;
		const rows = (item.shift_ubications || []).filter(
			(su) =>
				su.shift &&
				(!default_shift || su.shift.id !== default_shift.id)
		);

		return rows.map((shift_ubication) => {
			const shift = shift_ubication.shift;
			const time_intervals = shift.time_intervals;
			const title = `${shift.name}${
				shift.description ? ` - ${shift.description}` : ""
			}`;
			const textColor = getContrastColor(shift.background_color, "#55536b");

			return (
				<ContextMenuTrigger
					key={`${item.index}-ubi-${shift.id}`}
					id={MENU_ID}
					holdToDisplay={1000}
					collect={collect}
					onItemClick={this.handleMenuClick}
					index={item.index}
					shiftId={shift.id}
					cellType="ubication-shift"
				>
					<div
						className="sp-ubi-shift-block"
						role="button"
						tabIndex={0}
						onClick={(e) =>
							this.handleUbicationShiftBlockClick(e, item.index, shift.id)
						}
						onKeyDown={(e) => {
							if (e.key === "Enter" || e.key === " ") {
								e.preventDefault();
								this.applySelectedUbicationsToShift(item.index, shift.id);
							}
						}}
					>
						<div className="sp-ubi-shift-block__shift" aria-hidden="true">
							<ShiftPatternShiftTag
								className="sp-shift-tag--sm"
								name={shift.name}
								intervalLabels={this.formatShiftIntervalLabels(
									time_intervals
								)}
								style={{
									backgroundColor: shift.background_color || undefined,
									borderColor: shift.border_color
										? shift.border_color
										: shift.background_color || undefined,
									color: textColor,
									width: "100%",
									maxWidth: "100%",
								}}
								title={title}
							/>
						</div>
						<ul className="sp-ubi-shift-block__ubicaciones shift-list-items">
							{(shift_ubication.ubications || []).map((ubication) => {
								const uColor = getContrastColor(
									ubication.background_color,
									"#55536b"
								);
								const uTitle = `${ubication.name}${
									ubication.description
										? ` - ${ubication.description}`
										: ""
								}`;
								return (
									<li
										key={ubication.id}
										className="sp-grid-shift-cell-item sp-grid-shift-with-remove"
									>
										<div className="sp-grid-shift-with-remove__wrap">
											<ShiftPatternShiftTag
												className="sp-shift-tag--sm"
												name={ubication.name}
												intervalLabels={[]}
												style={{
													backgroundColor:
														ubication.background_color || undefined,
													borderColor: ubication.border_color
														? ubication.border_color
														: ubication.background_color ||
														  undefined,
													color: uColor,
													width: "100%",
													maxWidth: "100%",
												}}
												title={uTitle}
											/>
											<button
												type="button"
												className="sp-grid-shift-remove"
												aria-label={`Quitar ${ubication.name} del turno ${shift.name} (día ${item.index + 1})`}
												title={this.props.t("shiftPatterns.form.removeUbicationFromShift")}
												onClick={(e) =>
													this.handleRemoveUbicationFromShift(
														e,
														item.index,
														shift.id,
														ubication.id
													)
												}
											>
												<FiX aria-hidden strokeWidth={3} />
											</button>
										</div>
									</li>
								);
							})}
						</ul>
					</div>
				</ContextMenuTrigger>
			);
		});
	};

	applySelectedUbicationsToShift = (dayIndex, shiftId) => {
		const item = this.state.shift_pattern.items.find((x) => x.index === dayIndex);
		if (!item || !shiftId) return;
		const default_shift = this.props.default_shift;
		if (default_shift && Number(shiftId) === Number(default_shift.id)) return;

		const filtered = this._filterSelected(this.state.ubication_list);
		if (filtered.length === 0) return;

		const { shift_pattern } = this.state;
		const items = shift_pattern.items.map((it) => {
			if (it.index !== dayIndex) return it;
			const next = this.mergeUbicationsIntoOneShift(it, shiftId, filtered);
			return next !== null ? next : it;
		});

		this.setState({
			shift_pattern: { ...shift_pattern, items },
			errors: {},
		});
	};

	handleUbicationShiftBlockClick = (event, dayIndex, shiftId) => {
		event.preventDefault();
		event.stopPropagation();
		this.applySelectedUbicationsToShift(dayIndex, shiftId);
	};

	handleClearUbicationsForShift = (dayIndex, shiftId) => {
		const { shift_pattern } = this.state;
		const items = shift_pattern.items.map((item) => {
			if (item.index !== dayIndex) return item;
			const shift_ubications = (item.shift_ubications || []).map((su) =>
				su.shift && Number(su.shift.id) === Number(shiftId)
					? { ...su, ubications: [] }
					: su
			);
			return { ...item, shift_ubications, checked: false };
		});
		this.setState({
			shift_pattern: { ...shift_pattern, items },
			errors: {},
		});
	};

	handleClearAllUbications = () => {
		const { shift_pattern } = this.state;
		const items = shift_pattern.items.map((item) => ({
			...item,
			shift_ubications: (item.shift_ubications || []).map((su) => ({
				...su,
				ubications: [],
			})),
			checked: false,
		}));
		this.setState({
			shift_pattern: { ...shift_pattern, items },
			errors: {},
		});
	};

	handleRemoveUbicationFromShift = (
		event,
		dayIndex,
		shiftId,
		ubicationId
	) => {
		event.preventDefault();
		event.stopPropagation();
		const { shift_pattern } = this.state;
		const items = shift_pattern.items.map((item) => {
			if (item.index !== dayIndex) return item;
			const shift_ubications = (item.shift_ubications || []).map((su) =>
				su.shift && Number(su.shift.id) === Number(shiftId)
					? {
							...su,
							ubications: (su.ubications || []).filter(
								(u) => u.id !== ubicationId
							),
					  }
					: su
			);
			return { ...item, shift_ubications, checked: false };
		});
		this.setState({
			shift_pattern: { ...shift_pattern, items },
			errors: {},
		});
	};

	formatShiftIntervalLabels = (time_intervals) => {
		if (!time_intervals || time_intervals.length === 0) return [];
		return time_intervals.map((item) => {
			const start = convertFromUTC(item.start);
			const end = convertFromUTC(item.end);
			const short = (t) => {
				if (!t) return "";
				const [h, m] = t.split(":");
				return m === "00" ? h : `${h}:${m}`;
			};
			return `${short(start)}-${short(end)}h`;
		});
	};

	checkValidField = (name) => {
		return (
			this.state.submitted &&
			this.state.errors[name] !== undefined &&
			this.state.errors[name] !== ""
		);
	};

	prepareShiftPatternSubmit = () => {
		const { shift_pattern } = this.state;

		shift_pattern.items.map(function (sp_item) {
			const shift_ubication_ids = [];

			if (sp_item.shift_ubications) {
				sp_item.shift_ubications.map((shift_ubication) => {
					const shiftId =
						shift_ubication.shift && shift_ubication.shift.id;

					if (shiftId == null || shiftId === "") {
						return true;
					}

					const shift_ubication_item = {
						shift_id: shiftId,
						ubication_ids: [],
					};

					const ubication_ids = [];

					if (shift_ubication.ubications.length > 0) {
						shift_ubication.ubications.map((ubication) => {
							ubication_ids.push(ubication.id);
							return true;
						});

						shift_ubication_item.ubication_ids = ubication_ids;
					}

					shift_ubication_ids.push(shift_ubication_item);

					return true;
				});

				// console.log(shift_ubication_ids);
				sp_item.shift_ubication_ids = shift_ubication_ids;
			}
			return true;
		});
		// Add hasGroups and groupIds to the payload
		shift_pattern.has_groups = this.state.groupIds.length > 0;
		shift_pattern.group_ids = this.state.groupIds;

		return shift_pattern;
	};

	validateShiftPatternBeforeSubmit = () => {
		const { shift_pattern } = this.state;
		const errors = {};

		for (const sp_item of shift_pattern.items) {
			for (const shift_ubication of sp_item.shift_ubications || []) {
				const shiftId = shift_ubication.shift && shift_ubication.shift.id;
				if (shiftId == null || shiftId === "") {
					errors.general = this.props.t(
						"shiftPatterns.form.missingShift"
					);
					return errors;
				}
			}
		}

		return errors;
	};

	handleSubmit = async (event) => {
		event.preventDefault();
		const { isEdit } = this.state;

		const validationErrors = this.validateShiftPatternBeforeSubmit();
		if (validationErrors.general) {
			this.setState({
				submitted: true,
				errors: validationErrors,
			});
			return;
		}

		this.setState({ isLoading: true });
		let response = "";
		const props = this.props;
		const shift_pattern = this.prepareShiftPatternSubmit();

		// if edit => update; else => new
		if (isEdit) {
			response = await shiftPatternsService.update(shift_pattern);
		} else {
			response = await shiftPatternsService.add(shift_pattern);
		}

		// console.log(response);

		if (response.ok) {
			const persistedShiftPattern = { ...shift_pattern, ...response };
			const shouldHandoffToAssignment =
				!isEdit &&
				typeof props.onCreatedForAssignment === "function" &&
				persistedShiftPattern.id != null;

			this.setState(
				{
					isLoading: false,
					errors: {},
					...(isEdit
						? {}
						: { isEdit: true, shift_pattern: persistedShiftPattern }),
				},
				() => {
					toastr.success(
						this.props.t("common.success"),
						shouldHandoffToAssignment
							? this.props.t("shiftPatterns.savedOk")
							: this.props.t("common.changesSaved")
					);
					if (typeof props.getShiftPatterns === "function") {
						props.getShiftPatterns();
					}
					if (shouldHandoffToAssignment) {
						// Cierra el modal de creación; el padre abre el de asignación
						// como modal Redux limpio (evita backdrop Bootstrap encima).
						props.onCreatedForAssignment(persistedShiftPattern);
						return;
					}
					props.handleClose();
				}
			);
		} else {
			console.log(errorFormating(response));
			this.setState({
				isLoading: false,
				submitted: true,
				errors: errorFormating(response),
			});
		}
	};

	_hasSelection = (list) => {
		const result = list.find((o) => o.checked === true);
		return result !== undefined;
	};

	_filterSelected = (list) => {
		return list.filter((o) => o.checked === true);
	};

	handleMenuClick = (e, data, target) => {
		if (data.action === "paste-shifts") {
			this.applySelectedShiftsToDays(
				resolvePasteDayIndexes(this.state.selectedDayIndexes, data.index)
			);
		}
		if (data.action === "remove-shifts" && data.index != null) {
			this.handleRemoveShiftsAtIndex(data.index);
		}
		if (
			data.action === "paste-ubicaciones-shift" &&
			data.index != null &&
			data.shiftId != null
		) {
			this.applySelectedUbicationsToShift(data.index, data.shiftId);
		}
		if (
			data.action === "clear-ubicaciones-shift" &&
			data.index != null &&
			data.shiftId != null
		) {
			this.handleClearUbicationsForShift(data.index, data.shiftId);
		}
	};

	handleRemoveShiftsAtIndex = (index) => {
		const { shift_pattern } = this.state;
		const default_shift = this.props.default_shift;
		const items = shift_pattern.items.map((item) =>
			item.index === index
				? {
						...item,
						shift_ubications: [{ shift: default_shift, ubications: [] }],
						checked: false,
				  }
				: item
		);
		this.setState({
			shift_pattern: { ...shift_pattern, items },
			errors: {},
		});
	};

	handleRemoveShiftFromDay = (event, dayIndex, shiftId) => {
		event.preventDefault();
		event.stopPropagation();
		const { shift_pattern } = this.state;
		const default_shift = this.props.default_shift;
		if (!default_shift || shiftId === default_shift.id) return;

		const items = shift_pattern.items.map((item) => {
			if (item.index !== dayIndex) return item;
			const realOnly = (item.shift_ubications || []).filter(
				(su) => su.shift && su.shift.id !== default_shift.id
			);
			const kept = realOnly.filter((su) => su.shift.id !== shiftId);
			const shift_ubications =
				kept.length > 0
					? kept
					: [{ shift: default_shift, ubications: [] }];
			return { ...item, shift_ubications, checked: false };
		});

		this.setState({
			shift_pattern: { ...shift_pattern, items },
			errors: {},
		});
	};

	getShiftPaletteTags = () =>
		this.state.shift_list.map((item) => {
			const checked = item.checked || false;
			const textColor = getContrastColor(item.background_color, "#55536b");
			const title = `${item.name}${
				item.description ? ` - ${item.description}` : ""
			}`;

			return (
				<li
					key={item.id}
					role="listitem"
					title={title}
					className={`sp-palette-shift ${checked ? "is-selected" : ""}`}
				>
					<input
						type="checkbox"
						id={`${SP_SHIFT_CHECKBOX_ID_PREFIX}${item.id}`}
						onChange={this.handleShiftSelection}
						checked={checked}
					/>
					<label
						htmlFor={`${SP_SHIFT_CHECKBOX_ID_PREFIX}${item.id}`}
						className="sp-palette-shift__hit"
					>
						<ShiftPatternShiftTag
							name={item.name}
							intervalLabels={this.formatShiftIntervalLabels(
								item.time_intervals
							)}
							style={{
								backgroundColor: item.background_color || undefined,
								borderColor: item.border_color
									? item.border_color
									: item.background_color || undefined,
								color: textColor,
							}}
							title={title}
						/>
					</label>
				</li>
			);
		});

	getUbicationPaletteTags = () =>
		this.state.ubication_list.map((item) => {
			const checked = item.checked || false;
			const textColor = getContrastColor(item.background_color, "#55536b");
			const title = `${item.name}${
				item.description ? ` - ${item.description}` : ""
			}`;

			return (
				<li
					key={item.id}
					role="listitem"
					title={title}
					className={`sp-palette-shift ${checked ? "is-selected" : ""}`}
				>
					<input
						type="checkbox"
						id={`${SP_UBICATION_CHECKBOX_ID_PREFIX}${item.id}`}
						onChange={this.handleUbicationSelection}
						checked={checked}
					/>
					<label
						htmlFor={`${SP_UBICATION_CHECKBOX_ID_PREFIX}${item.id}`}
						className="sp-palette-shift__hit"
					>
						<ShiftPatternShiftTag
							name={item.name}
							intervalLabels={[]}
							style={{
								backgroundColor: item.background_color || undefined,
								borderColor: item.border_color
									? item.border_color
									: item.background_color || undefined,
								color: textColor,
							}}
							title={title}
						/>
					</label>
				</li>
			);
		});

	getAssignedShifts = (sp_item) => {
		const default_shift = this.props.default_shift;
		return sp_item.shift_ubications.map((shift_ubication) => {
			const shift = shift_ubication.shift;
			const time_intervals = shift.time_intervals;
			const title = `${shift.name}${
				shift.description ? ` - ${shift.description}` : ""
			}`;
			const textColor = getContrastColor(shift.background_color, "#55536b");
			const isPlaceholder =
				default_shift && shift.id === default_shift.id;
			return (
				<li
					key={shift.id}
					title={title}
					className="sp-grid-shift-cell-item sp-grid-shift-with-remove"
				>
					<div className="sp-grid-shift-with-remove__wrap">
						<ShiftPatternShiftTag
							className="sp-shift-tag--sm"
							name={shift.name}
							intervalLabels={this.formatShiftIntervalLabels(time_intervals)}
							style={{
								backgroundColor: shift.background_color || undefined,
								borderColor: shift.border_color
									? shift.border_color
									: shift.background_color || undefined,
								color: textColor,
								width: "100%",
								maxWidth: "100%",
							}}
							title={title}
						/>
						{!isPlaceholder && (
							<button
								type="button"
								className="sp-grid-shift-remove"
								aria-label={`Quitar ${shift.name} del día ${sp_item.index + 1}`}
								title={this.props.t("shiftPatterns.form.removeShiftFromDay")}
								onClick={(e) =>
									this.handleRemoveShiftFromDay(e, sp_item.index, shift.id)
								}
							>
								<FiX aria-hidden strokeWidth={3} />
							</button>
						)}
					</div>
				</li>
			);
		});
	};

	getTotalWorkingHours = (time_intervals) => {
		let totalMinutes = 0;
		const format = "HH:mm";

		if (!Array.isArray(time_intervals)) return 0;

		time_intervals.forEach((interval) => {
			if (
				!interval?.start ||
				!interval?.end ||
				!interval.time_type?.counts_as_total_hours
			)
				return;

			// Si los tiempos vienen en UTC, hay que convertirlos
			const startStr = convertFromUTC(interval.start); // ej. "22:00"
			const endStr = convertFromUTC(interval.end); // ej. "06:00"

			let start = moment(startStr, format);
			let end = moment(endStr, format);

			// Ajustar si el turno cruza medianoche
			if (end.isSameOrBefore(start)) {
				end.add(1, "day");
			}

			const minutes = end.diff(start, "minutes");
			totalMinutes += minutes;
		});

		return totalMinutes / 60;
	};

	getTotalHoursForItems = (items) => {
		let total = 0;

		items.forEach((item) => {
			if (!item.shift_ubications) return;

			item.shift_ubications.forEach((su) => {
				if (su.shift && su.shift.time_intervals) {
					total += this.getTotalWorkingHours(su.shift.time_intervals);
				}
			});
		});

		return total;
	};

	formatHours = (value) => {
		const hasDecimals = value % 1 !== 0;
		if (hasDecimals) {
			const rounded = value.toFixed(2).replace(".", ",");
			const trimmed = rounded.replace(/,?0+$/, ""); // quita ceros y coma si sobra
			return `${trimmed}h`;
		}
		return `${value}h`;
	};

	getShiftCells = () => {
		const { shift_pattern, errors, selectedDayIndexes } = this.state;
		const items = shift_pattern.items;
		const selectedDays = new Set(selectedDayIndexes || []);
		const daysPerRow = 7;
		const rows = [];

		for (let i = 0; i < items.length; i += daysPerRow) {
			const rowItems = items.slice(i, i + daysPerRow);
			const rowHours = this.getTotalHoursForItems(rowItems);

			rows.push(
				<div key={`row-${i}`} className="pattern-row">
					{rowItems.map((item, j) => {
						const index = i + j;
						const hasError = !!errors[`items[${index}].shift_ids`];

						const isDaySelected = selectedDays.has(item.index);

						return (
							<article
								key={item.index}
								className={`sp-day-cell pattern-cell ${
									isDaySelected ? "is-day-selected" : ""
								} ${hasError ? "error" : ""}`}
							>
								<ContextMenuTrigger
									id={MENU_ID}
									holdToDisplay={1000}
									collect={collect}
									onItemClick={this.handleMenuClick}
									index={item.index}
									cellType="shift"
								>
									<div
										className="sp-day-cell__inner"
										role="button"
										tabIndex={0}
										aria-pressed={isDaySelected}
										onMouseDown={(e) => this.beginDayDrag(e, item.index)}
										onMouseEnter={(e) =>
											this.handleDayMouseEnter(e, item.index)
										}
										onContextMenu={() =>
											this.handleDayContextMenu(item.index)
										}
										onClick={(e) => this.handleDayAssignClick(e, item.index)}
										onKeyDown={(e) => {
											if (e.key === "Enter" || e.key === " ") {
												e.preventDefault();
												this.applySelectedShiftsToDay(item.index);
											}
										}}
									>
										<span className="cell-number sp-day-cell__num">
											{item.index + 1}
										</span>
										<div className="sp-day-cell__body">
											{item.shift_ubications && (
												<ul className="shift-list-items">
													{this.getAssignedShifts(item)}
												</ul>
											)}
										</div>
									</div>
								</ContextMenuTrigger>
							</article>
						);
					})}
					<button
						type="button"
						className={`pattern-cell summary-cell sp-week-total${
							rowItems.every((rowItem) => selectedDays.has(rowItem.index))
								? " is-row-selected"
								: ""
						}`}
						aria-label={this.props.t("shiftPatterns.form.selectWeekRow")}
						onClick={() =>
							this.handleWeekRowSelection(rowItems.map((rowItem) => rowItem.index))
						}
					>
						<strong>{this.formatHours(rowHours)}</strong>
					</button>
				</div>
			);
		}

		const totalHours = this.getTotalHoursForItems(items);
		rows.push(
			<div key="total" className="pattern-total-row text-right mt-2">
				{this.props.t("shiftPatterns.form.totalHours")} <strong>{this.formatHours(totalHours)}</strong>
			</div>
		);

		return rows;
	};

	getUbicationCells = () => {
		const { shift_pattern, errors } = this.state;
		const items = shift_pattern.items;
		const daysPerRow = 7;
		const rows = [];

		for (let i = 0; i < items.length; i += daysPerRow) {
			const rowItems = items.slice(i, i + daysPerRow);
			const rowHours = this.getTotalHoursForItems(rowItems);

			rows.push(
				<div key={`ub-row-${i}`} className="pattern-row">
					{rowItems.map((item, j) => {
						const index = i + j;
						const hasError = !!errors[`items[${index}].ubication_id`];
						const hasAssignable = this.itemHasAssignableShifts(item);

						return (
							<article
								key={item.index}
								className={`sp-day-cell pattern-cell ${hasError ? "error" : ""
									} ${!hasAssignable ? "sp-day-cell--ubi-no-shifts" : ""}`}
							>
								<div
									className={`sp-day-cell__inner${!hasAssignable ? " sp-day-cell__inner--ubi-locked" : ""
										}`}
								>
									<span className="cell-number sp-day-cell__num">
										{item.index + 1}
									</span>
									<div
										className={`sp-day-cell__body${hasAssignable ? " sp-day-cell__body--ubi-per-shift" : ""
											}`}
									>
										{hasAssignable && this.getUbicationShiftBlocks(item)}
									</div>
								</div>
							</article>
						);
					})}
					<div className="pattern-cell summary-cell">
						<strong>{this.formatHours(rowHours)}</strong>
					</div>
				</div>
			);
		}

		const totalHours = this.getTotalHoursForItems(items);
		rows.push(
			<div key="total" className="pattern-total-row text-right mt-2">
				{this.props.t("shiftPatterns.form.totalHours")} <strong>{this.formatHours(totalHours)}</strong>
			</div>
		);

		return rows;
	};

	// TODO provar (com?)
	getItemError = () => {
		const { shift_pattern, errors } = this.state;
		var errorMsg = "";

		shift_pattern.items.map((item, i) => {
			if (errors["items[" + i + "].shift_ids"] !== undefined) {
				errorMsg = errors["items[" + i + "].shift_ids"];
			} else if (errors["items[" + i + "].ubication_id"] !== undefined) {
				errorMsg = errors["items[" + i + "].ubication_id"];
			}
			return true;
		});

		if (errorMsg !== "") {
			return (
				<InlineAlert variant="error" className="mt15">
					{errorMsg}
				</InlineAlert>
			);
		}
	};

	renderSelectedShiftPills = () => {
		const shifts = this._filterSelected(this.state.shift_list);
		if (shifts.length === 0) return null;

		return (
			<ul
				className="sp-assign-mode-banner__pills"
				aria-label={this.props.t("shiftPatterns.form.selectedShiftsPreview")}
			>
				{shifts.map((item) => {
					const textColor = getContrastColor(item.background_color, "#55536b");
					const title = `${item.name}${
						item.description ? ` - ${item.description}` : ""
					}`;

					return (
						<li key={item.id}>
							<ShiftPatternShiftTag
								className="sp-shift-tag--sm"
								name={item.name}
								intervalLabels={this.formatShiftIntervalLabels(
									item.time_intervals
								)}
								style={{
									backgroundColor: item.background_color || undefined,
									borderColor: item.border_color
										? item.border_color
										: item.background_color || undefined,
									color: textColor,
								}}
								title={title}
							/>
						</li>
					);
				})}
			</ul>
		);
	};

	renderShiftAssignBanner = () => {
		const selectedDayCount = (this.state.selectedDayIndexes || []).length;
		const copiedCount = (this.state.copiedDayPattern || []).length;
		const hasPaletteShiftSelection = this._hasSelection(this.state.shift_list);
		const canPasteOnSelection =
			selectedDayCount > 0 && hasPaletteShiftSelection;
		const isActive =
			hasPaletteShiftSelection || selectedDayCount > 0 || copiedCount > 0;

		let text;
		if (canPasteOnSelection) {
			text = this.props.t("shiftPatterns.form.selectedDaysPasteHint", {
				count: selectedDayCount,
			});
		} else if (selectedDayCount > 0) {
			text = this.props.t("shiftPatterns.form.selectedDaysNeedShifts", {
				count: selectedDayCount,
			});
		} else if (copiedCount > 0) {
			text = this.props.t("shiftPatterns.form.copiedPatternHint", {
				count: copiedCount,
			});
		} else if (hasPaletteShiftSelection) {
			text = this.props.t("shiftPatterns.form.assignModeShifts");
		} else {
			text = this.props.t("shiftPatterns.form.selectShiftsHint");
		}

		if (copiedCount > 0 && selectedDayCount > 0) {
			text = `${text} ${this.props.t("shiftPatterns.form.copiedPatternReady", {
				count: copiedCount,
			})}`;
		}

		return (
			<div
				className={
					"sp-assign-mode-banner" + (isActive ? " is-active" : "")
				}
			>
				<div className="sp-assign-mode-banner__copy" title={text}>
					{hasPaletteShiftSelection && (
						<RxCopy className="sp-assign-mode-banner__icon" aria-hidden />
					)}
					{text}
				</div>
				<div className="sp-assign-mode-banner__tray">
					{this.renderSelectedShiftPills()}
					{(hasPaletteShiftSelection || canPasteOnSelection) && (
						<div className="sp-assign-mode-banner__actions">
							{hasPaletteShiftSelection && (
								<button
									type="button"
									className="btn btn-outline-secondary btn-sm sp-assign-mode-banner__clear"
									onClick={this.handlePaletteBorrar}
									aria-label={this.props.t(
										"shiftPatterns.form.clearShiftsAriaLabel"
									)}
								>
									<BiEraser aria-hidden />
									{this.props.t("shiftPatterns.form.clearShiftsSelection")}
								</button>
							)}
							{canPasteOnSelection && (
								<button
									type="button"
									className="btn btn-primary btn-sm sp-assign-mode-banner__paste"
									onClick={this.handlePasteSelectedDays}
								>
									{this.props.t("shiftPatterns.form.pasteShifts")}
								</button>
							)}
						</div>
					)}
				</div>
			</div>
		);
	};

	getShiftContent = () => {
		const { shift_types } = this.props;
		const { shift_pattern } = this.state;

		const optionShiftTypeList =
			shift_types.length > 0 &&
			shift_types.map((item, i) => {
				return (
					<option key={i} value={item.name}>
						{item.name}
					</option>
				);
			}, this);

		const optionShiftPatternLength =
			this.state.length_options.length > 0 &&
			this.state.length_options.map((item) => {
				return (
					<option key={item.index} value={item.index + 1}>
						{item.index + 1} {this.props.t("shiftPatterns.form.days")}
					</option>
				);
			}, this);

		return (
		<div className="pattern-container pattern-container--stacked">
			<div className="pattern-filter pattern-filter--shifts pattern-filter--above-calendar">
				<div className="pattern-box">
					<ShiftPatternSelector
						searchValue={this.state.searchShift}
						onSearchChange={this.handleShiftSearchChange}
						filterTypeId={this.state.filterTypeId}
						onFilterTypeChange={this.handleFilterTypeChange}
						shiftTypeOptions={optionShiftTypeList}
						showClearButton={false}
						toolbarTrailing={
							<FormGroup
								className="form-group sp-pattern-grid-panel__length"
								controlId="length"
							>
								<FormLabel>
									{this.props.t("shiftPatterns.form.cycleLengthLabel")}
								</FormLabel>
								<FormControl
									value={shift_pattern.length}
									onChange={this.handlePatternLengthChange}
									as="select"
									aria-label={this.props.t(
										"shiftPatterns.form.cycleLengthAriaLabel"
									)}
								>
									{optionShiftPatternLength}
								</FormControl>
							</FormGroup>
						}
					>
						{this.getShiftPaletteTags()}
					</ShiftPatternSelector>
					</div>
				</div>
				<div className="sp-grid-top-bar">
					{this.renderShiftAssignBanner()}
				</div>
				<div className="sp-pattern-grid-panel">
					<div className="pattern-plan shift-plan">{this.getShiftCells()}</div>
				</div>
			</div>
		);
	};

	getUbicationContent = () => {
		const { shift_pattern } = this.state;

		const optionShiftPatternLength =
			this.state.length_options.length > 0 &&
			this.state.length_options.map((item) => {
				return (
					<option key={item.index} value={item.index + 1}>
						{item.index + 1} {this.props.t("shiftPatterns.form.days")}
					</option>
				);
			}, this);

		return (
			<div className="pattern-container pattern-container--stacked">
				<div className="pattern-filter pattern-filter--shifts pattern-filter--above-calendar">
					<div className="pattern-box">
						<ShiftPatternSelector
							searchValue={this.state.searchUbication}
							onSearchChange={this.handleUbicationSearchChange}
							searchControlId="searchUbication"
							searchPlaceholder={this.props.t("shiftPatterns.form.searchUbicationsPlaceholder")}
							searchAriaLabel={this.props.t("shiftPatterns.form.searchUbicationsAriaLabel")}
							showTimeTypeFilter={false}
							hintText={this.props.t("shiftPatterns.form.ubLocationHint")}
							onBorrarClick={this.handleUbicationPaletteBorrar}
							hasSelection={this._hasSelection(this.state.ubication_list)}
							borrarButtonText={this.props.t("shiftPatterns.form.clearUbicationsSelection")}
							borrarAriaLabel={this.props.t("shiftPatterns.form.clearUbicationsAriaLabel")}
						>
							{this.getUbicationPaletteTags()}
						</ShiftPatternSelector>
					</div>
				</div>
				<div className="sp-grid-top-bar">
					<div
						className={
							"sp-assign-mode-banner" +
							(this._hasSelection(this.state.ubication_list)
								? " is-active"
								: "")
						}
					>
						<div className="sp-assign-mode-banner__copy">
							{this._hasSelection(this.state.ubication_list) ? (
								<>
									<RxCopy
										className="sp-assign-mode-banner__icon"
										aria-hidden
									/>{" "}
									{this.props.t("shiftPatterns.form.assignModeUbications")}
								</>
							) : (
								this.props.t("shiftPatterns.form.selectUbicationsHint")
							)}
						</div>
						<div className="sp-assign-mode-banner__tray" aria-hidden="true" />
					</div>
					<div className="sp-pattern-grid-panel__header">
						<FormGroup
							className="form-group sp-pattern-grid-panel__length"
							controlId="length-ubicaciones"
						>
							<FormLabel>{this.props.t("shiftPatterns.form.cycleLengthLabel")}</FormLabel>
							<FormControl
								value={shift_pattern.length}
								onChange={this.handlePatternLengthChange}
								as="select"
								aria-label={this.props.t("shiftPatterns.form.cycleLengthAriaLabel")}
							>
								{optionShiftPatternLength}
							</FormControl>
						</FormGroup>
					</div>
				</div>
				<div className="sp-pattern-grid-panel">
					<div className="pattern-plan shift-plan shift-plan--ubicaciones">
						{this.getUbicationCells()}
					</div>
				</div>
			</div>
		);
	};

	getGroupsTabContent = () => {
		const groups = this.getPatternGroups();
		const selected = this.getSelectedPatternGroups(groups);

		return (
			<div className="groups-tab-content">
				<div className="row mb-3">
					<div className="col-md-6">
						<CatalogMultiSelect
							label={this.props.t("shiftPatterns.form.addGroup")}
							items={groups}
							selected={selected}
							labelOf={(group) => group.name}
							chipOf={(group) =>
								catalogChip(
									group,
									group.name,
									this.props.t("common.delete")
								)
							}
							searchPlaceholder={this.props.t("common.catalog.searchGroup")}
							onToggleItem={this.togglePatternGroup}
							onClear={this.clearPatternGroups}
						/>
						<p className="text-muted" style={{ marginTop: "10px" }}>
							{this.props.t("shiftPatterns.form.groupsOnlyHint")}
						</p>
					</div>
				</div>
			</div>
		);
	};

	getTabsContent = (hasUbications) => {
		const { isEdit, employees, shift_pattern } = this.state;
		const tabId = `shift-pattern-tabs-${isEdit ? "edit" : "new"}`;
		return (
			<Tab.Container
				id={tabId}
				activeKey={this.state.activePatternTab}
				onSelect={this.handlePatternTabSelect}
			>
				<div className="sp-tabs-toolbar">
					<Nav
						variant="pills"
						className="sp-shift-pattern-segmented sp-tabs-toolbar__tabs"
					>
						<Nav.Item>
							<Nav.Link eventKey="turnos">{this.props.t("shiftPatterns.form.tabShifts")}</Nav.Link>
						</Nav.Item>
						{hasUbications && (
							<Nav.Item>
								<Nav.Link eventKey="ubicaciones">{this.props.t("shiftPatterns.form.tabUbications")}</Nav.Link>
							</Nav.Item>
						)}
						<Nav.Item>
							<Nav.Link eventKey="grupos">{this.props.t("shiftPatterns.form.tabGroups")}</Nav.Link>
						</Nav.Item>
						<Nav.Item>
							<Nav.Link eventKey="empleados">{this.props.t("shiftPatterns.form.tabEmployees")}</Nav.Link>
						</Nav.Item>
					</Nav>
					<div className="sp-tabs-toolbar__ubications">
						<div className="sp-tabs-toolbar__ubications-inner">
							<FormLabel
								htmlFor="has_ubications"
								className="sp-tabs-toolbar__ubications-label"
							>
								{this.props.t("shiftPatterns.form.addUbicationsLabel")}
							</FormLabel>
							<SwitchCompact
								controlId="has_ubications"
								isOn={hasUbications}
								handleToggle={this.handleSwitch}
							/>
						</div>
					</div>
				</div>
				<Tab.Content>
					<Tab.Pane eventKey="turnos">{this.getShiftContent()}</Tab.Pane>
					{hasUbications && (
						<Tab.Pane eventKey="ubicaciones">
							{this.getUbicationContent()}
						</Tab.Pane>
					)}
					<Tab.Pane eventKey="grupos">{this.getGroupsTabContent()}</Tab.Pane>
					<Tab.Pane eventKey="empleados">
						<ShiftPatternEmployees
							employees={employees}
							shiftPatternId={shift_pattern.id}
							onEditEmployee={this.openNestedEditAssignment}
							onAddEmployee={this.openNestedAddPickEmployee}
							onRemoveEmployee={this.openNestedDeleteAssignment}
							onCloneEmployee={this.openNestedCloneAssignment}
						/>
					</Tab.Pane>
				</Tab.Content>
			</Tab.Container>
		);
	};

	render() {
		const { shift_pattern, errors, length_options } = this.state;

		const hasPaletteShiftSelection = this._hasSelection(this.state.shift_list);
		const optionShiftPatternLength =
			length_options.length > 0 &&
			length_options.map((item) => {
				return (
					<option key={item.index} value={item.index + 1}>
						{item.index + 1} {this.props.t("shiftPatterns.form.days")}
					</option>
				);
			}, this);

		// const isUbicationSelected = this._hasSelection(this.state.ubication_list) && this._hasSelection(this.state.shift_pattern.items);
		const isUbicationSelected = this._hasSelection(this.state.ubication_list);
		const hasUbications = shift_pattern.has_ubications;
		const isEnabled = shift_pattern.enabled;

		return (
			<>
				{this.state.isLoadingDetails ? (
					<Loading />
				) : (
					<form
						className="shift-pattern-edit-modal-form"
						onSubmit={this.handleSubmit}
					>
						<div className="modal-body shift-pattern-edit shift-pattern-edit-modal">
							<div className="sp-form-basic">
								<FormTextField
									controlId="name"
									label={this.props.t("common.name")}
									value={shift_pattern.name}
									onChange={this.handleChange}
									placeholder={this.props.t("common.name")}
									isInvalid={this.checkValidField("name")}
									error={errors.name || ""}
									required
									className="sp-form-basic__name"
								/>
								<FormTextField
									controlId="description"
									label={this.props.t("common.description")}
									value={shift_pattern.description}
									onChange={this.handleChange}
									placeholder={this.props.t("common.description")}
									isInvalid={this.checkValidField("description")}
									error={errors.description || ""}
									className="sp-form-basic__description"
								/>
								<div className="sp-form-basic__active">
									<FormLabel htmlFor="enabled" className="sp-form-basic__switch-label">
										{this.props.t("shiftPatterns.form.activeLabel")}
									</FormLabel>
									<SwitchCompact
										controlId="enabled"
										isOn={isEnabled}
										handleToggle={this.handleSwitch}
									/>
								</div>
							</div>

							{this.getTabsContent(hasUbications)}

							<div className="form-error">{this.getItemError()}</div>

							{this.state.errors && this.state.errors.general && (
								<InlineAlert variant="error">
									{this.state.errors.general}
								</InlineAlert>
							)}
						</div>

						<div className="modal-footer">
							{this.state.activePatternTab === "turnos" && (
								<button
									type="button"
									onClick={this.handleClearAllPattern}
									className="btn btn-outline-secondary"
								>
									{this.props.t("shiftPatterns.form.clearAll")}
								</button>
							)}
							{this.state.activePatternTab === "ubicaciones" && (
								<button
									type="button"
									onClick={this.handleClearAllUbications}
									className="btn btn-outline-secondary"
								>
									{this.props.t("shiftPatterns.form.clearUbications")}
								</button>
							)}
							<button
								type="button"
								onClick={this.props.handleClose}
								className="btn btn-outline-primary"
							>
								{this.props.t("common.cancel")}
							</button>
							<SubmitButton
								type="submit"
								isLoading={this.state.isLoading}
								text={this.props.t("common.save")}
								loadingText={this.props.t("common.saving")}
							/>
						</div>

						<CustomContextMenu
							hasPaletteShiftSelection={hasPaletteShiftSelection}
							isUbicationSelected={isUbicationSelected}
						/>
					</form>
				)}
				{this.renderNestedEmployeeModals()}
			</>
		);
	}
}

const mapStateToProps = (reducers) => {
	return {
		...reducers.calendarsReducer,
		...reducers.timesReducer,
		...reducers.shiftsReducer,
		...reducers.ubicationsReducer,
		loading: reducers.shiftsReducer.loading,
	};
};

const mapDispatchToProps = (dispatch) => ({
	getAllShifts: (options) => dispatch(shiftsActions.getAllShifts(options)),
	getShiftTypes: () => dispatch(shiftsActions.getShiftTypes()),
	getSelectableShifts: () => dispatch(shiftsActions.getSelectableShifts()),
	getDefaultShift: () => dispatch(shiftsActions.getDefaultShift()),
	getSelectableUbications: (options) =>
		dispatch(ubicationsActions.getSelectableUbications(options)),
	getDefaultShift: () => dispatch(shiftsActions.getDefaultShift()),
});

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(ShiftPatternEdit));

function collect(props) {
	return props;
}

// Context menu:
const ShiftPatternContextMenu = (props) => {
	const { t } = useTranslation();
	// console.log(props);
	const { trigger, isUbicationSelected, hasPaletteShiftSelection } = props;
	const handleItemClick = trigger ? trigger.onItemClick : null;
	const cellType = trigger ? trigger.cellType : "shift";
	const cellIndex =
		trigger && typeof trigger.index === "number" ? trigger.index : null;

	if (cellType === "ubication-shift") {
		const rawShiftId = trigger ? trigger.shiftId : null;
		const shiftId =
			rawShiftId != null ? Number.parseInt(String(rawShiftId), 10) : null;
		const validShiftId =
			shiftId != null && !Number.isNaN(shiftId) ? shiftId : null;

		return (
			<ContextMenu id={MENU_ID}>
				{trigger &&
					isUbicationSelected &&
					cellIndex !== null &&
					validShiftId != null && (
						<MenuItem
							onClick={handleItemClick}
							data={{
								action: "paste-ubicaciones-shift",
								index: cellIndex,
								shiftId: validShiftId,
							}}
						>
							{t("shiftPatterns.form.addUbicationsToShift")}
						</MenuItem>
					)}
				{trigger && cellIndex !== null && validShiftId != null && (
					<MenuItem
						onClick={handleItemClick}
						data={{
							action: "clear-ubicaciones-shift",
							index: cellIndex,
							shiftId: validShiftId,
						}}
					>
						{t("shiftPatterns.form.pasteUbications")}
					</MenuItem>
				)}
				{trigger && !isUbicationSelected && (
					<MenuItem
						onClick={handleItemClick}
						data={{ action: "remove-ubications" }}
					>
						{t("shiftPatterns.form.deleteUbications")}
					</MenuItem>
				)}
			</ContextMenu>
		);
	}
	return (
		<ContextMenu id={MENU_ID}>
			{trigger && hasPaletteShiftSelection && cellIndex !== null ? (
				<MenuItem
					onClick={handleItemClick}
					data={{ action: "paste-shifts", index: cellIndex }}
				>
					{t("shiftPatterns.form.pasteShifts")}
				</MenuItem>
			) : (
				<React.Fragment />
			)}
		</ContextMenu>
	);
};

const CustomContextMenu = connectMenu(MENU_ID)(ShiftPatternContextMenu);
